import { JsonRPCServer } from "./JsonRPCServer";
import { WalletEvent } from "./WalletAPI";
export class MsafeServer {
    constructor(connector, methods) {
        this.server = new JsonRPCServer(connector, methods);
    }
    changeNetwork(network) {
        this.server.notify(WalletEvent.ChangeNetwork, [network]);
    }
    changeAccount(account) {
        this.server.notify(WalletEvent.ChangeAccount, [account]);
    }
}
//# sourceMappingURL=MsafeServer.js.map